import { random } from '../../core/helpers/random';
import { BONUS_RESPONSE, FREE_SPINS_STATE } from '../../stateManagment/gameState';
import { crystalPerTypeHelper } from './CrystalPerTypeHelper';


/**
 * @typedef {Object} BonusResponse
 * @property {number} odd
 * @property {number} result
 * @property {number} totalWinAmount
 * @property {number} remainingSpinCount
 */

export class BonusSpinResponseHelper {
  constructor() {
    this.request = null;
  }

  getRandomNum() {
    const { result } = this.getData();
    const { length } = crystalPerTypeHelper.crystalPerType[result];
    const index = length > 1 ? random(0, length - 1) : 0;
    return crystalPerTypeHelper.crystalPerType[result][index];
  }

  notNull() {
    return BONUS_RESPONSE.getValue() !== null;
  }

  nullify() {
    BONUS_RESPONSE.next(null);
  }

  /**
   * @name setData
   * @param {Object} data
   * @param {string} data.demoBonusId
   * @param {number} data.result
   * @param {number} data.winAmount
   */
  setData(data) {
    BONUS_RESPONSE.next(data);
  }

  /**
   *
   * @return {BonusResponse}
   */
  getData() {
    return BONUS_RESPONSE.getValue();
  }

  getRandomCrystal(type) {
    const { length } = crystalPerTypeHelper.crystalPerType[type];
    const index = length > 1 ? random(0, length - 1) : 0;
    return crystalPerTypeHelper.crystalPerType[type][index];
  }

  setCrystalPlace({ oldType, newType, index }) {
    const i = crystalPerTypeHelper.crystalPerType[oldType].findIndex(e => e === index);
    crystalPerTypeHelper.crystalPerType[oldType].splice(i, 1);
    crystalPerTypeHelper.crystalPerType[newType].push(index);
  }

  decrementFreeSpin() {
    FREE_SPINS_STATE.next(FREE_SPINS_STATE.getValue() - 1);
  }

  getFreeSpinCount() {
    return FREE_SPINS_STATE.getValue();
  }

  cancelDelay() {
    if (this.request) {
      this.request.cancel();
      this.request = null;
    }
  }

  setDelay(req) {
    this.request = req;
  }

  pause() {
    this.cancelDelay();
  }

  get hasError() {
    return this.spinError;
  }

  resetError() {
    this.spinError = null;
  }

  setError(error) {
    this.spinError = error;
  }
}

export const bonusSpinResponseHelper = new BonusSpinResponseHelper();
